import React from "react";
import { graphql } from "gatsby";

import Layout from "../../components/layout";

import Section from "../../components/organisms/section";
import Header from "../../components/organisms/header";
import Footer from "../../components/organisms/footer";
import FormApply from "../../components/organisms/form-apply";

import HeaderBrand from "../../components/molecules/header-brand";
import FooterBrand from "../../components/molecules/footer-brand";
import FooterNav from "../../components/molecules/footer-nav";
import FooterCopy from "../../components/molecules/footer-copy";
import NavBar from "../../components/molecules/navbar";
import HeaderTitle from "../../components/molecules/header-title";
import List from "../../components/molecules/list";
import ListItem from "../../components/molecules/list-item";
import ImageContainer from "../../components/molecules/image-container";
import HeaderSubfacet from "../../components/molecules/header-subfacet";
import ButtonApply from "../../components/molecules/button-apply";

import Seo from "../../components/atoms/seo";
import FormWrapper from "../../components/organisms/form-wrapper";
import Progress from "../../components/atoms/progress";
import Versus from "../../components/atoms/versus";

class FrontEndDeveloper extends React.Component {
  render() {
    return (
      <Layout location={this.props.location}>
        <Seo
          title="Tim | Front-End Developer | Silhouette"
          media="https://www.blastic.com/design/img/background/tim-no-brand.jpg"
          description="Blastic is looking for a front-end developer profile. The silhouette of one of our front-end developers reveals what the job includes and what you can expect."
        />
        <Header>
          <HeaderBrand />
          <NavBar
            context={this.props.pageContext.intl}
            language={this.props.pageContext.language}
          />
        </Header>
        <ButtonApply getTarget={() => document.getElementsByTagName("form")[0]}>
          Meet <br />
          <br />
          Tim
        </ButtonApply>
        <Section className="pt-5 py-sm-5">
          <HeaderTitle title="Tim | Front-End Developer" />
          <div className="row">
            <div className="col-md-6 pb-6 order-2 order-md-1">
              <p>
                Enabling companies to create unique and inspirational digital
                customer experiences, that is what I like to do. Bringing
                back-end, design and SEO flawlessly together through creativity
                and persistence is how I realise this. I’m here to ensure that
                the message of our customers is presented accurately on a
                website which works quickly and feels intuitive.
              </p>
              <p>
                Converting designs into responsive layouts through code (HTML,
                JS, CSS, …) and giving them the ultimate usability on every
                screen, in every browser. This means I’m patiently optimising
                every detail: testing, testing and did I mention testing?
              </p>
              <p>
                In the next few years, I believe our job will shift towards
                Headless CMS. I’m viewing this as an evolution of the
                traditional CMS via the As a Service principle. When we meet up,
                this will be my first question: how do you believe Headless will
                impact Front-End jobs, if at all?
              </p>
            </div>
            <div className="ml-auto col-md-5 order-1 order-md-2">
              <ImageContainer
                fluid={this.props.data.frontEndDeveloper.childImageSharp.fluid}
                overlay="gradient"
                negateRight={true}
                negateBottom={true}
                aspectRatio="1x1-5"
              >
                <h3 className="h6">I'm looking for a colleague</h3>
                <HeaderSubfacet title="Role" value="Front-End Developer" />
                <HeaderSubfacet title="Experience" value="> 2 years" />
                <HeaderSubfacet
                  title="Location"
                  value="Edegem (Antwerp) or Ghent"
                />
                <HeaderSubfacet title="Language" value="NL / EN / JS" />
                <HeaderSubfacet
                  title="Pay"
                  value="45K – 60K yearly (includes: insurance, car & fuel card, ...)"
                />
              </ImageContainer>
            </div>
          </div>
        </Section>
        <Section className="py-5 py-sm-7 section-shifted-left-blue">
          <div className="row">
            <div className="col-lg-11 ml-auto">
              <div className="row">
                <div className="col-sm-6">
                  <h2 className="h4 mb-2">What drives me in my job</h2>
                  <List>
                    <ListItem>Deliverying Experiences</ListItem>
                    <ListItem>
                      Constant challenge, 'pressure' and variation
                    </ListItem>
                    <ListItem>Open communication, with a great team!</ListItem>
                    <ListItem>Freedom and work/life balance</ListItem>
                  </List>
                </div>
                <div className="col-sm-6">
                  <h2 className="h4 mb-2 mt-sm-7">I'm turned off by</h2>
                  <List>
                    <ListItem>Messy or overengineered code</ListItem>
                    <ListItem>'One size fits all' - projects</ListItem>
                    <ListItem>9-to-5 mentality</ListItem>
                  </List>
                </div>
              </div>
            </div>
          </div>
        </Section>
        <Section className="py-5 py-sm-6 section-white">
          <div className="row">
            <div className="col-12 col-md-4 mr-auto negate-top pb-5 pb-md-0">
              <h2 className="h4">Personality</h2>
              <Versus
                value={70}
                scale={100}
                title="Introvert"
                titleOpponent="Extravert"
              />
              <Versus
                value={50}
                scale={100}
                title="Organized"
                titleOpponent="Chaotic"
              />
              <Versus value={30} scale={100} title="Think" titleOpponent="Do" />
              <Versus
                value={80}
                scale={100}
                title="Reserved"
                titleOpponent="Assertive"
              />
              <Versus
                value={35}
                scale={100}
                title="No-nonsense"
                titleOpponent="Diplomatic"
              />
              <Versus
                value={20}
                scale={100}
                title="Creative"
                titleOpponent="Analytical"
              />
            </div>
            <div className="col-6 col-md-4 col-lg-3 ml-auto">
              <h2 className="h4">Skills</h2>
              <Progress value={90} scale={100} title="JavaScript" />
              <Progress value={90} scale={100} title="HTML / CSS / SASS" />
              <Progress value={60} scale={100} title="React / Angular / Vue" />
              <Progress value={70} scale={100} title="Service Workers & PWAs" />
              <Progress value={50} scale={100} title="Headless CMS" />
              <Progress value={70} scale={100} title="Testing" />
            </div>
            <div className="col-6 col-md-4 col-lg-3 mx-auto">
              <h2 className="h4">Motivators</h2>
              <Progress value={70} scale={100} title="Quality" />
              <Progress value={80} scale={100} title="Personal growth" />
              <Progress value={60} scale={100} title="Creativity" />
              <Progress value={80} scale={100} title="Focus & persistence" />
              <Progress
                value={90}
                scale={100}
                title="Performance optimization"
              />
              <Progress value={50} scale={100} title="Agility & adaptability" />
            </div>
          </div>
        </Section>
        <FormWrapper path="Front-End">
          <FormApply className="section-grey">
            <h2 className="form-title mb-4">Meet Tim</h2>
            <div className="row">
              <div className="col-md-6 mb-4 mr-auto">
                <p>
                  Do you feel attracted to Tim’s job and his presentation?
                  Perfect! If you’d like to catch up and craft your own
                  Front-End Development job with us, please don’t hesitate to
                  reach out.
                </p>
              </div>
            </div>
          </FormApply>
        </FormWrapper>
        <Footer>
          <FooterBrand />
          <FooterNav language={this.props.pageContext.language} />
          <FooterCopy />
        </Footer>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    frontEndDeveloper: file(
      relativePath: { eq: "background/tim-no-brand.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 600) {
          # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export default FrontEndDeveloper;
